import { render, staticRenderFns } from "./SidebarBackoffice.vue?vue&type=template&id=1a52364e&"
import script from "./SidebarBackoffice.vue?vue&type=script&lang=js&"
export * from "./SidebarBackoffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports